import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

import PatientBackground from "./PatientRxBackground.jpg";

export const background = css`
  height: 100vh;
  background-image: url("${PatientBackground}");
  background-color: ${colors.background};
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: ${dimensions.desktopMax}) {
    background-position: 5% center;
  }
`;
